import { __awaiter } from "tslib";
import { FetchError } from './FetchError';
import { ERROR__networkError__message } from './i18n.messages';
import { getMessage } from './i18n.service';
export function doFetch(url, init) {
    function doFetch(resolve, reject) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const resp = yield fetch(url, init);
                let json;
                try {
                    json = (yield resp.json());
                }
                catch (e) {
                    console.error("Can't parse output");
                }
                if (resp.status < 200 || resp.status >= 300) {
                    reject(new FetchError(getMessage(ERROR__networkError__message), resp, json));
                    return;
                }
                //const json = await resp.json();
                resolve(json);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    return new Promise(doFetch);
}
